module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fields":"Fields"},"es":{"fields":"Cultivos"},"sw":{"fields":"Mashamba"}}')
  delete Component.options._Ctor
}
